export function getQngieDownwardAdjustment(tooltips = {}) {
  return {
    expenses_related_party: {
      label:
        "Relevant expense amounts included in ANGIE which relate to transactions with, or amounts owed to a person who is a related party of a member of the group - s414(3)(a)",
      type: "negative",
      notes: tooltips.expenses_related_party,
    },
    expenses_related_financial_assistance: {
      label:
        "Relevant expense amounts included in ANGIE treated as being owed to a related party due to certain guarantees, indemnities or other financial assistance - s414(3)(a) / s466",
      type: "negative",
      notes: tooltips.expenses_related_financial_assistance,
    },
    expenses_dependent_securities: {
      label:
        "Relevant expense amounts included in ANGIE which relate to results-dependent securities - s414(3)(b)",
      type: "negative",
      notes: tooltips.expenses_dependent_securities,
    },
    expenses_equity_notes: {
      label:
        "Relevant expense amounts included in ANGIE which relate to equity notes - s414(3)(c)",
      type: "negative",
      notes: tooltips.expenses_equity_notes,
    },
    specialist_regimes_adjustments: {
      label: "Other adjustments required as a result of specialist regimes",
      type: null,
      notes: tooltips.specialist_regimes_adjustments,
    },
    miscellaneous_adjustments: {
      label: "Other adjustments for which there is no space above",
      type: null,
      notes: tooltips.miscellaneous_adjustments,
    },
  };
}

export function getQngieInterestAllowance(tooltips = {}) {
  return {
    qngie_proportion_associated_groups_s427_5: {
      label:
        "Adjustment to include the appropriate proportion of the QNGIE of each associated worldwide group headed by a company specified in the election - s427(5)",
      type: "positive",
      notes: tooltips.qngie_proportion_associated_groups_s427_5,
    },
  };
}

export function getQngieAdjustmentsForQualifyingInfrastructureCompanies(
  tooltips = {},
) {
  return {
    exclude_qic_income_exempt_s440_s442_2b: {
      label:
        "Adjustment to exclude relevant income amounts of a QIC that were exempted under s440 and are included in the group financial statements - s442(2)(b)",
      type: null,
      notes: tooltips.exclude_qic_income_exempt_s440_s442_2b,
    },
    exclude_qic_expense_exempt_s438_s442_2b: {
      label:
        "Adjustment to exclude relevant expense amounts of a QIC that were exempted under s438 (including as applied by s439) and are included in the group financial statements - s442(2)(b)",
      type: null,
      notes: tooltips.exclude_qic_expense_exempt_s438_s442_2b,
    },
  };
}

export function getQngieRowConfig(tooltips = {}) {
  return {
    // Downward Adjustment
    ...getQngieDownwardAdjustment(tooltips),

    //Interest Allowance (non-consolidated)
    ...getQngieInterestAllowance(tooltips),

    //Adjustments for Qualifying Infrastructure Companies
    ...getQngieAdjustmentsForQualifyingInfrastructureCompanies(tooltips),
  };
}
